import React, { Component } from 'react';
class Awards extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
        <div className="container-xxl mt-5" id="aboutus">
            <div className="container inner_con">
            <div className="row g-4">
              <h1 className="text-start mb-2 wow fadeInUp title_view" data-wow-delay="0.1s">About Us</h1>
                <div className="row g-4">
                    <div className="col-lg-12 wow fadeIn margin_top_zero" data-wow-delay="0.5s">
                      <p className="mb-4"><b>BYLAWS Legal LLP (BYLAWS)</b> is a multi-disciplinary law firm providing legal, regulatory,
                      transactional and dispute-resolution services across a broad spectrum of industries and practice
                      areas. The firm is structured to support clients through complex legal and regulatory environments
                      with clarity, discipline and professional integrity.</p>
                      <p className="mb-4">Our practice is founded on a principled approach to law, combining rigorous legal analysis with
                      practical understanding of business, regulation and institutional processes. We advise corporates,
                      financial institutions, regulated entities and professionals across both contentious and non-
                      contentious matters.</p>
                      <p className="mb-2">BYLAWS operates with a clear focus on regulatory alignment, governance discipline and risk-
                      aware legal strategy. Whether advising on compliance frameworks, corporate structuring,
                      transactional execution or litigation, the firm places strong emphasis on precision, accountability
                      and ethical conduct.</p>
                     </div>
                  </div>
              </div>
            </div>
        </div>
    );
  }
}

export default Awards;
